module.exports = __webpack_public_path__ + "static/data_bar_5-8aeccb9d015037c1ff9824e328347274.png";